import { useAppScopeStore } from '@frontend/scope';
import { useMessagingAIRCustomizationFlag, useVoiceAIRCustomizationFlag } from '@frontend/shared';

export const useAiReceptionistAccess = () => {
  const { selectedLocationIds } = useAppScopeStore();

  const { isActive: hasTlAiVoiceAccess } = useVoiceAIRCustomizationFlag(selectedLocationIds);
  const { isActive: hasTlAiMessagingAccess } = useMessagingAIRCustomizationFlag(selectedLocationIds);

  const hasAiReceptionistAccess = hasTlAiVoiceAccess || hasTlAiMessagingAccess;

  return {
    hasTlAiVoiceAccess,
    hasTlAiMessagingAccess,
    hasAiReceptionistAccess,
  };
};
